module.exports = __webpack_public_path__ + "static/img/劍橋大飯店.3f5dba7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/建置實績/劍橋大飯店.png?20181011
// module id = 5sXl
// module chunks = 1